export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20atmosphere%20with%20soft%20warm%20golden%20spotlights%20on%20a%20dark%20stage%20background%2C%20abstract%20film%20strip%20texture%20with%20gentle%20bokeh%20lights%2C%20elegant%20theater%20curtain%20draping%20at%20edges%2C%20deep%20contrast%20cinematic%20lighting%20with%20warm%20amber%20highlights%2C%20professional%20movie%20theater%20atmosphere%2C%20no%20text%2C%20clean%20composition%2C%20high%20detail%20cinematic%20photography&width=1800&height=800&seq=hero-bg-cinema-01&orientation=landscape"
          alt="6080新视觉影院 - 电影背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium tracking-wide mb-5 whitespace-nowrap">
              每日更新 · 高清流畅 · 免费观看
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              6080新视觉影院 —
              <br className="hidden sm:block" />
              免费高清电影在线观看
            </h1>

            <p className="text-base md:text-lg text-background-50/80 font-heading mb-6">
              最新电影电视剧全集，极速秒开不卡顿
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              6080新视觉影院致力于为影迷提供海量高清电影与热门电视剧免费在线观看服务。平台每日同步更新院线新片、热播剧集与经典老片，覆盖动作、喜剧、科幻、悬疑、动漫等全题材类型。本站采用智能加速引擎，实现视频秒开不缓冲，无论手机还是电脑都能畅享流畅高清观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                  30000+
                </div>
                <div className="text-xs text-background-50/60 mt-1">海量影片资源</div>
              </div>
              <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  1080P
                </div>
                <div className="text-xs text-background-50/60 mt-1">高清画质保障</div>
              </div>
              <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                  秒开
                </div>
                <div className="text-xs text-background-50/60 mt-1">智能极速引擎</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors duration-200"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20collage%20composition%20with%20film%20reels%20and%20warm%20golden%20spotlight%20effects%2C%20dramatic%20theater%20lighting%20with%20rich%20amber%20and%20deep%20shadow%20contrast%2C%20classic%20movie%20elements%20floating%20artistically%2C%20vintage%20cinema%20aesthetic%20with%20modern%20twist%2C%20elegant%20composition%2C%20no%20text%2C%20warm%20color%20palette%20with%20golden%20highlights&width=1200&height=750&seq=hero-visual-cinema-02&orientation=landscape"
                alt="6080新视觉影院 - 精彩影视体验"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex-1 bg-background-50/15 backdrop-blur-sm rounded-lg px-4 py-2.5 flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                  <span className="text-xs text-background-50/90 whitespace-nowrap">正在热播中</span>
                  <span className="text-xs text-background-50/60 ml-auto whitespace-nowrap">HD 1080P</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}